import { RouterProvider } from 'react-router-dom';
import { mainRouter, authRouter } from './router';

function isAuthDomain() {
  if (typeof window === 'undefined') return false;
  const hosts = ['a.techassembly.io', 'auth.techassembly.io'];
  return hosts.includes(window.location.hostname);
}

function App() {
  return <RouterProvider router={isAuthDomain() ? authRouter : mainRouter} />;
}

export default App;
